export default __webpack_public_path__ + "static/assets/d38976c0b055490c92eb0d765af4153b.svg";